import React, { ReactNode } from 'react';
import styled from 'styled-components';

import DepositWithdrawalButtons from '#/components/balances/DepositWithdrawalButtons';
import HeaderMobile from '#/components/layout/header/HeaderMobile';
import { useNavigateToPrevious } from '#/lib/redirect';
import { useSelector } from '#/reduxState/store';

const MaxWidthBlock = styled.div`
  width: 100%;
  /* max-width: 1440px; */
  /* margin: 0 auto; */
  padding: 0 12px 0;
  border-radius: 2px;
  background: var(--elevation-light);
  .isMobileStyle & {
    width: calc(100% - 8px);
    margin: 0 4px;
    /* margin: initial; */
    padding-top: 12px;
  }
`;

const Header = styled(MaxWidthBlock)`
  padding: 12px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  > h1 {
    padding: 0;
    margin: 0;
  }
`;

// const Divider = styled.div`
//   border-bottom: 1px solid var(--separator);
// `;

const Flex = styled.div`
  display: flex;
  gap: 8px;
  .isMobileStyle & {
    width: 100%;
  }
`;

function WalletHeader({
  title,
  showBalanceActions,
  contentRight,
  noBack,
  children,
}: {
  title: ReactNode;
  showBalanceActions: boolean;
  contentRight?: ReactNode;
  noBack?: boolean;
  children?: ReactNode;
}) {
  const isMobile = useSelector(state => state.screen.isMobile);
  const navigatePrevious = useNavigateToPrevious(
    isMobile ? '/wallet/menu-mobile' : '/wallet'
  );
  return (
    <>
      {isMobile && (
        <HeaderMobile
          chainLogo={noBack}
          onBackClick={noBack ? undefined : navigatePrevious}
        >
          {title}
        </HeaderMobile>
      )}

      {(!isMobile || contentRight || showBalanceActions) && (
        <Header>
          {!isMobile && <h1>{title}</h1>}
          <Flex>
            {contentRight}
            {showBalanceActions && <DepositWithdrawalButtons />}
          </Flex>
        </Header>
      )}
      {children && <MaxWidthBlock>{children}</MaxWidthBlock>}
      {/* <Divider /> */}
    </>
  );
}

export default WalletHeader;

//     ) : state.activeAction === 'transfer' ? (
//       <TransferAction
//         ethereumWalletBalance={state.walletBalances[nativeAssetSymbol]}
//         token={modalActiveToken}
//         tokenWalletBalance={
//           state.walletBalances
//             ? state.walletBalances[modalActiveToken.symbol] || '0'
//             : '0'
//         }
//         onClose={() => dispatch({ type: 'clearActiveAction' })}
//       />
